import Request from './Request'

const AssociateMarketService = {
	cached_data: null,
	async getAssociateMarkets() {
		if( !AssociateMarketService.cached_pods ) {
			const _data = await Request.get('/api/associate-markets')	
			AssociateMarketService.cached_data = _data
		}
		return AssociateMarketService.cached_data
	},
}

export default AssociateMarketService